import gql from "graphql-tag";
const BASE_CONTACTS_LOOKUP = gql`
	query (
		$onlyActive: Boolean
		$where: BaseContactFilterInput
		$order: [BaseContactSortInput!]
		$skip: Int
		$take: Int
	) {
		baseContacts(
			onlyActive: $onlyActive
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			pageInfo {
				hasNextPage
			}
			items {
				id
				name
			}
		}
	}
`;
const BASE_USERS_LOOKUP = gql`
	query ($onlyUsers: Boolean) {
		contactsAdm(onlyUsers: $onlyUsers) {
			items {
				name
				user {
					id
					userName
				}
			}
		}
	}
`;
const ROLES_LOOKUP = gql`
	query {
		roles {
			id
			name
		}
	}
`;
const LDAP_GROUPS = gql`
	query {
		ldapGroups(take: 999) {
			items {
				id
				name
				distinguishedName
			}
		}
	}
`;
const LDAP_GROUP_SETTINGS = gql`
	query {
		ldapGroupSettings {
			port
			distinguishedName
			nameAttribute
			searchFilter
			userSearchFilter
			sidAttribute
		}
	}
`;
const ROLES_SECTION = gql`
	query {
		roles {
			id
			name
			syncWithLdap
			ldapGroup {
				id
				name
			}
			users {
				id
				userName
			}
		}
	}
`;
const SOCIAL_NETWORK = gql`
	query {
		items: socialNetworks {
			items {
				id
				name
			}
		}
	}
`;
const MY_USER_AUTH_PROVIDERS = gql`
	query {
		items: myUserAuthProviders {
			id
			authProviderId
			value
			userName
			isAdditional
		}
	}
`;
const CONTACT_SESSIONS = gql`
	query (
		$where: ContactSessionFilterInput
		$order: [ContactSessionSortInput!]
		$skip: Int
		$take: Int
	) {
		items: contactSessions(
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			pageInfo {
				hasNextPage
			}
			items {
				id
				start
				end
				isActive
			}
		}
	}
`;
const MY_CONTACT = gql`
	query {
		myContact {
			id
			name
			firstName
			lastName
			typeId
			verificationStatusId
			photoId
			email
			phoneNumber
		}
	}
`;
const MY_CONTACT_PROFILE = gql`
	query {
		myContact {
			id
			name
			firstName
			lastName
			birthDate
			age
			email
			photo {
				id
			}
			photos {
				id: fileId
			}
		}
	}
`;
const MY_CHATS = gql`
	query (
		$where: MyChatResponseFilterInput
		$order: [MyChatResponseSortInput!]
		$skip: Int
		$take: Int
	) {
		items: myChats(where: $where, order: $order, skip: $skip, take: $take) {
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				chat {
					id
					name
					lastMessage {
						id
						text
						createdOn
						isSeen
						replyToMessageId
						contactId
						files {
							id
							name
							typeId
							extension
							contentType
							duration
						}
					}
					participants {
						id
						contact {
							id
							name
							photoId
						}
						lastViewedOn
					}
				}
				unreadCount
			}
		}
	}
`;
const GET_MY_CHAT_BY_ID = gql`
	query ($id: UUID!) {
		items: myChatById(id: $id) {
			items {
				chat {
					id
					name
					lastMessage {
						id
						text
						createdOn
						isSeen
						replyToMessageId
						contactId
						files {
							id
							name
							typeId
							extension
							contentType
							duration
						}
					}
					participants {
						id
						contact {
							id
							name
							photoId
						}
						lastViewedOn
					}
				}
				unreadCount
			}
		}
	}
`;
const TRANSLATE_MESSAGE = gql`
	query ($id: UUID) {
		items: translateMessage(message: { id: $id })
	}
`;
const MESSAGES_BY_CHAT = gql`
	query (
		$where: MessageFilterInput
		$order: [MessageSortInput!]
		$skip: Int
		$take: Int
	) {
		items: messages(
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				id
				text
				createdOn
				isSeen
				replyToMessage {
					id
					text
					createdOn
					isSeen
					contactId
					files {
						id
						name
						typeId
						extension
						contentType
						duration
					}
				}
				contactId
				files {
					id
					name
					typeId
					extension
					contentType
					duration
				}
			}
		}
	}
`;
const UNREAD_MESSAGES_COUNT = gql`
	{
		unreadMessagesCount
	}
`;
const PUBLIC_ARTICLES = gql`
	query ($where: PublicArticleFilterInput) {
		items: publicArticles(where: $where) {
			items {
				id
				title
				metaTitle
				metaDescription
				content
				code
				modifiedOn
			}
		}
	}
`;
const PUBLIC_ARTICLES_FOR_EDIT = gql`
	query ($where: PublicArticleFilterInput) {
		items: publicArticlesForEdit(where: $where) {
			items {
				id
				title
				metaTitle
				metaDescription
				content
				code
				culture {
					id
				}
				position
				isShowOnMain
				isTile
				tileTitle
				tileFileId
			}
		}
	}
`;
const CHECK_TOKEN = gql`
	query {
		checkToken {
			isLoggedIn
			logoutReason
			authData {
				status
				message
				token
				expiration
				contact
				roles
				policies
			}
		}
	}
`;
const SESSION_SETTINGS = gql`
	query {
		sessionSettings {
			idleTimeoutInMinutes
		}
	}
`;
const CONTACT_COMMENTS = gql`
	query (
		$where: ContactCommentQueryResponseFilterInput
		$order: [ContactCommentQueryResponseSortInput!]
		$skip: Int
		$take: Int
	) {
		items: contactCommentsWithLike(
			where: $where
			order: $order
			skip: $skip
			take: $take
		) {
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				comment {
					id
					text
					author {
						id
						name
						photoId
					}
					createdOn
					parentId
				}
				isLikedByMe
				reactionsCount
				childrenCount
			}
		}
	}
`;
const SYSTEM_SETTINGS = gql`
	query (
		$where: SystemSettingFilterInput
		$order: [SystemSettingSortInput!]
	) {
		systemSettings(where: $where, order: $order) {
			items {
				id
				code
				name
				value
			}
		}
	}
`;
const POLICIES = gql`
	query {
		policies {
			id
			name
			description
			roles {
				id
				name
			}
		}
	}
`;
const USERS = gql`
	query (
		$where: BaseContactFilterInput
		$order: [BaseContactSortInput!]
		$skip: Int
		$take: Int
	) {
		contactsAdm(
			where: $where
			order: $order
			skip: $skip
			take: $take
			onlyUsers: true
		) {
			totalCount
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
			items {
				id
				name
				createdOn
				firstName
				lastName
				isOnline
				isActive
				photoId
				preset
				user {
					id
					roles {
						id
						name
					}
					userName
					email
					authProviders {
						value
						authProvider {
							id
							name
						}
					}
				}
			}
		}
	}
`;
const GET_USER_SETTING = gql`
	query ($key: String!) {
		settings {
			user {
				setting_value: setting(key: $key)
			}
		}
	}
`;
const GET_USER_DEFAULT_SETTING = gql`
	query ($key: String!) {
		settings {
			user {
				setting_value: defaultSetting(key: $key)
			}
		}
	}
`;
const GET_USER_SETTINGS = gql`
	query ($keys: [String!]!) {
		settings {
			user {
				setting_value: settings(keys: $keys) {
					key
					data
				}
			}
		}
	}
`;
const GET_USER_DEFAULT_SETTINGS = gql`
	query ($keys: [String!]!) {
		settings {
			user {
				setting_value: defaultSettings(keys: $keys) {
					key
					data
				}
			}
		}
	}
`;
const ADMIN_GET_DEFAULT_SETTING = gql`
	query {
		settings {
			admin {
				setting_value: defaultSettings {
					key
					data
					isDefault
				}
			}
		}
	}
`;
const ADMIN_GET_CONTACT_SETTINGS = gql`
	query ($contactId: UUID) {
		settings {
			admin {
				setting_value: contactSettings(contactId: $contactId) {
					key
					data
					isDefault
				}
			}
		}
	}
`;
export {
  ADMIN_GET_CONTACT_SETTINGS,
  ADMIN_GET_DEFAULT_SETTING,
  BASE_CONTACTS_LOOKUP,
  BASE_USERS_LOOKUP,
  CHECK_TOKEN,
  CONTACT_COMMENTS,
  CONTACT_SESSIONS,
  GET_MY_CHAT_BY_ID,
  GET_USER_DEFAULT_SETTING,
  GET_USER_DEFAULT_SETTINGS,
  GET_USER_SETTING,
  GET_USER_SETTINGS,
  LDAP_GROUPS,
  LDAP_GROUP_SETTINGS,
  MESSAGES_BY_CHAT,
  MY_CHATS,
  MY_CONTACT,
  MY_CONTACT_PROFILE,
  MY_USER_AUTH_PROVIDERS,
  POLICIES,
  PUBLIC_ARTICLES,
  PUBLIC_ARTICLES_FOR_EDIT,
  ROLES_LOOKUP,
  ROLES_SECTION,
  SESSION_SETTINGS,
  SOCIAL_NETWORK,
  SYSTEM_SETTINGS,
  TRANSLATE_MESSAGE,
  UNREAD_MESSAGES_COUNT,
  USERS
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
